import { Injectable } from '@angular/core';
import { FormGroup, ValidationErrors } from '@angular/forms';
import { EnumFieldName } from '../models/enums/enumFieldName';

declare let alertify: any;

@Injectable({
    providedIn: 'root'
})

export class AlertifyService {

    constructor() { }

    // @msg {String or DOMElement} Message content
    // @wait {Number} Time (in seconds) to wait before the message is dismissed, a value of 0 means keep open till clicked.
    // @callback {Function} A callback function to be invoked when the message is dismissed.
    success(msg: string, wait = 0, callback = null) {
        alertify.success(msg, wait, callback);
    }

    error(msg: string, wait = 0, callback = null) {
        alertify.error(msg, wait, callback);
    }

    message(msg: string, wait = 0, callback = null) {
        alertify.message(msg, wait, callback);
    }

    warning(msg: string, wait = 0, callback = null) {
        alertify.warning(msg, wait, callback);
    }

    confirm(title: string, msg: string, cancelCallback?: () => any): Promise<any> {
        return new Promise((resolve, reject) => {
            alertify.confirm(title, msg, function () {
                if(!resolve){
                    reject(true);
                }
                resolve(true);
            }, function () { 
                if(cancelCallback)
                    cancelCallback();
            }).set({'closableByDimmer': false, 'movable': false, transition:'fade', transitionOff: true}).set('labels', {ok:'Sim', cancel:'Não'});
        })
    }

    alertaImportacao(title: string, msg: string[], cancelCallback?: () => any): Promise<any> {
        return new Promise((resolve, reject) => {
            alertify.confirm(title, msg.join('<br/>'), function () {
                if(!resolve){
                    reject(true);
                }
                resolve(true);
            }, function () { 
                if(cancelCallback)
                    cancelCallback();
            }).set({'closableByDimmer': false, 'movable': false, transition:'fade', transitionOff: true}).set('labels', {ok:'Ok'});
        })
    }

    validaFormErros(form: FormGroup) {
        let errorsFields = [];

        Object.keys(form.controls).forEach(field => {

            const controlErrors: ValidationErrors = form.controls[field].errors;

            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    errorsFields.push({'field': field, 'type_erro': keyError, status: controlErrors[keyError]});
                });
            }
        });
       
        if(errorsFields.length > 3) {
            this.error('Ops. Há muitos campos vazios', 3, 'error');
        }else{
            errorsFields.forEach(key => {
                switch(key.type_erro) {
                    case 'Not valid': case 'Mask error': case 'pattern':
                        this.error(`O campo <b>${EnumFieldName[key.field] ? EnumFieldName[key.field] : key.field}</b> é inválido. ${key.field == 'email' ? 'Não é permitido espaço, acentuação e caracteres especiais' : ''}`, 3, 'error');
                        break;
                    case 'required': case 'Empty': case 'Not Selected':  case 'Undefined' :
                        this.error(`O campo <b>${EnumFieldName[key.field] ? EnumFieldName[key.field] : key.field}</b> é obrigatório.`, 3, 'error');
                        break;
                    case 'Sum dif 100': 
                        this.error("A soma da <b>regra de pagamento</b> está diferente de 100%.", 3);
                        break;
                }
            });
        }
    }
}
